import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
// dev environment importeren
import { environment } from "../environments/environment";
import { AngularFireModule } from "@angular/fire";
import { AngularFireStorageModule } from "@angular/fire/storage";
//DocumentReference inladen -> hiermee kan je een reference ophalen in een collectie naar een ander doc
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { VaaComponent } from './modules/vaa-module/vaa.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotFoundComponent } from './not-found/not-found.component';
import { LoginComponent } from './login/login.component';
import { AuthService } from "./services/auth.service";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AdminComponent } from './admin/admin.component';
import { LogoutComponent } from './logout/logout.component';
import { AdminVaaComponent } from './admin/admin-vaa/admin-vaa.component';
import { ColorPickerComponent } from './admin/color-picker/color-picker.component';
import { AdminAanwerfsimulatorComponent } from './admin/admin-aanwerfsimulator/admin-aanwerfsimulator.component';
import { AdminCash4bikeComponent } from './admin/admin-cash4bike/admin-cash4bike.component';
import { AdminHolidayValueComponent } from './admin/admin-holiday-value/admin-holiday-value.component';
import { ModalContentComponent } from './shared/modal-content/modal-content.component';
import { ToastComponent } from './shared/toast/toast.component';
import { Cash4BikeComponent } from './modules/cash4-bike/cash4-bike.component';
import { RemoveCommaPipe } from './shared/removeCommaPipe';
import { HolidayValueComponent } from './modules/holiday-value/holiday-value.component';
import { AanwerfsimulatorComponent } from './modules/aanwerfsimulator/aanwerfsimulator.component';
import { SstoolsComponent } from './sstools/sstools.component';
import { DataService } from './services/data.service';
import { PrivateAdminComponent } from './admin/private-admin/private-admin.component';
import { UnderConstructionComponent } from './shared/under-construction/under-construction.component';
import { OpzegtermijnComponent } from './modules/opzegtermijn/opzegtermijn.component';
import { KoopkrachtpremieComponent } from './modules/koopkrachtpremie/koopkrachtpremie.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LandingPageComponent,
    VaaComponent,
    NotFoundComponent,
    LoginComponent,
    ResetPasswordComponent,
    AdminComponent,
    LogoutComponent,
    AdminVaaComponent,
    ColorPickerComponent,
    AdminAanwerfsimulatorComponent,
    AdminCash4bikeComponent,
    AdminHolidayValueComponent,
    ModalContentComponent,
    ToastComponent,
    Cash4BikeComponent,
    RemoveCommaPipe,
    HolidayValueComponent,
    AanwerfsimulatorComponent,
    SstoolsComponent,
    PrivateAdminComponent,
    UnderConstructionComponent,
    OpzegtermijnComponent,
    KoopkrachtpremieComponent,

  ],
  imports: [
    CommonModule,
    NgbModule,
    BrowserModule,
    AppRoutingModule,

    AngularFireModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    
    

  ],
  providers: [AuthService, ToastComponent, DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
